import { execOnLoad } from '@general/helpers';
import { throttle } from 'lodash';
import './header.scss';
import { closeModal, openModal } from '@components/modals';
import { afterCartChangeType, getCart } from '@services/cart';
import breakpoints from 'breakpoints';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initHeader = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const backgroundContainer = sectionContainer.querySelector(
    '.header__background',
  );
  if (backgroundContainer) {
    const resizeCallback = throttle(
      () =>
        document.documentElement.style.setProperty(
          '--header-height',
          `${backgroundContainer.clientHeight}px`,
        ),
      500,
    );
    resizeCallback();
    window.addEventListener('resize', resizeCallback);

    const announcementBarHeight =
      document.documentElement.style.getPropertyValue(
        '--announcement-bar-height',
      );
    const scrollOffset = announcementBarHeight
      ? parseInt(announcementBarHeight.replace('px', ''))
      : 0;
    if (typeof backgroundContainer.dataset.transparent !== 'undefined') {
      const scrollCallback = throttle(() => {
        if (sectionContainer.querySelector('.mobile-menu__container.open'))
          return;
        backgroundContainer.dataset.transparent =
          window.scrollY <= scrollOffset;
      }, 500);
      scrollCallback();
      window.addEventListener('scroll', scrollCallback);
    }
  }

  const cartIcon = sectionContainer.querySelector('.header__action--cart');
  const minicart = document.querySelector('#MinicartDrawer');
  if (cartIcon && minicart)
    cartIcon.addEventListener('click', (e) => {
      e.preventDefault();
      openModal(minicart);
    });

  const cartCounter = sectionContainer.querySelector(
    '.header__action-cart-counter',
  );
  if (cartCounter) {
    document.addEventListener(afterCartChangeType, async () => {
      const cart = await getCart();
      if (cart) cartCounter.innerText = cart.item_count;
    });
  }

  const searchWrapper = sectionContainer.querySelector('.header__search');
  const searchIcon = sectionContainer.querySelector('.header__action--search');
  if (searchWrapper && searchIcon) {
    const mainInput = searchWrapper.querySelector('input[name="q"]');
    const closeWrapper = searchWrapper.querySelector('.header__search-close');
    if (mainInput && closeWrapper) {
      const closeSearch = () => {
        backgroundContainer.dataset.searchOpen = 'false';
        mainInput.value = '';
        mainInput.dispatchEvent(new Event('input', { bubbles: true }));
      };
      closeWrapper.addEventListener('click', closeSearch);
      searchIcon.addEventListener('click', (e) => {
        e.preventDefault();
        if (backgroundContainer.dataset.searchOpen == 'true') {
          closeSearch();
        } else {
          backgroundContainer.dataset.searchOpen = 'true';
          mainInput.focus();

          const openMobileMenu = sectionContainer.querySelector(
            '.mobile-menu__container',
          );
          if (openMobileMenu) {
            const modal = openMobileMenu.querySelector('.modal');
            openMobileMenu.classList.remove('open');
            closeModal(modal);
          }
        }
      });
    }
  }

  const headerLogo = sectionContainer.querySelector('.header__logo');
  if (
    headerLogo &&
    window.innerWidth > parseInt(breakpoints.lg) &&
    headerLogo.classList.contains('big') &&
    headerLogo.classList.contains('hidden')
  ) {
    if (window.scrollY == 0) {
      headerLogo.classList.remove('hidden');

      requestAnimationFrame(() => {
        window.addEventListener(
          'scroll',
          () => headerLogo.classList.remove('big'),
          { once: true },
        );
      });
    } else {
      const onTransitionEnd = (event) => {
        if (['top', 'width', 'transform'].includes(event.propertyName)) {
          headerLogo.classList.remove('hidden');
          headerLogo.removeEventListener('transitionend', onTransitionEnd);
        }
      };

      headerLogo.addEventListener('transitionend', onTransitionEnd);
      headerLogo.classList.remove('big');
    }
  }
};

execOnLoad(window.dAgency.initHeader, '.header__section');
